<template>
    <v-container class="pa-0" fluid>
      <el-overlay-loading :loading="pageloading" />
      <!-- title  -->
      <h1 class="mb-1">{{ $t('Asmens dokumento rūšys') }}</h1>
      <!-- add button  -->
      <el-button
        class="mb-5"
        color="primary"
        icon="pridėti"
        title="Pridėti naują"
        :loading="loading"
        @click.native.stop="newItem()"
      />
      <!-- search -->
      <person-document-kind-search
        :loading="loading"
        @search="initSearch"
      />
      <!-- table -->
      <v-data-table
        class="mb-4 custom-table sticky-header"
        :loading="loading || paginationloading"
        :headers="filteredHeader"
        :items="filterItemList"
        :hide-default-footer="hideFooter"
        :header-props="{
          sortByText: $t('Rūšiuoti pagal')
        }"
        :footer-props="{
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageText: $t('Rodyti po:'),
          itemsPerPageAllText: $t('visi'),
          itemsPerPageOptions: itemsPerPageOptions,
        }"
        :sort-by.sync="pagination.sort"
        :sort-desc.sync="pagination.sortDesc"
        :server-items-length="pagination.total"
        :items-per-page="pagination.pageSize"
        :page.sync="pagination.page"
        @update:options="updatePagination"
      >
        <!-- custom templates -->
  
        <!--main custom templates -->
        <template #[`item.actions`]="{ item }">
          <div class="nowrap">
            <el-table-action
              :item="item"
              @editItem="editItem(item)"
              @viewItem="editItem(item)"
              @deleteItem="deleteItem(item)"
              @restoreItem="restoreItem(item)"
            />
          </div>
        </template>
        <!-- basic templates -->
        <template slot="loading"> {{ $t('Kraunasi...') }} </template>
        <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
        <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
        <template #[`footer.page-text`]="props">
          {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
          {{ props.itemsLength }}
        </template>
      </v-data-table>
       <modal-delete
        title="Šalinti įrašą"
        text="Ar tikrai norite pašalinti įrašą?"
        v-model="showDelete"
        :loading="loading"
        :item="modalDeleteItem"
        @confirmDelete="confirmDelete"
      />
    </v-container>
  </template>
  
  <script>
  import PersonDocumentKindSearch from './PersonDocumentKindSearch'
  import userRole from '@/mixins/userRole'
  import ModalDelete from '@/components/modals/ModalDelete'
  import tableParameters from '@/mixins/tableParameters'
  
  export default {
    name: 'PersonDocumentKind',
    components: {
      PersonDocumentKindSearch,
      ModalDelete,
    },
    mixins: [userRole, tableParameters],
    data() {
      return {
        pageloading: true,
        loading: true,
        paginationloading: false,
        search: null,
        showDelete: false,
        modalDeleteItem: null,
        listData: [],
        searchData: {},
  
        itemsPerPageOptions: [10, 50, 100],
        pagination: {
          page: 1,
          pageSize: 100,
          total: 0,
          totalPages: 0,
          sort: null,
          sortDesc: [],
          direction: 'asc',
        },
      }
    },
    computed: {
      headers() {
        return [
          {
            text: this.$t('Veiksmai'),
            align: 'center',
            sortable: false,
            value: 'actions',
          },
          {
            text: this.$t('Trumpinys'),
            align: 'start',
            value: 'code',
          },
          {
            text: this.$t('Pavadinimas (LT)'),
            align: 'start',
            value: 'title_lt',
          },
          {
            text: this.$t('Pavadinimas (EN)'),
            align: 'start',
            value: 'title_en',
          },
          {
            text: this.$t('Galioja nuo'),
            align: 'start',
            value: 'valid_from',
            width: "8rem"
          },
          {
            text: this.$t('Galioja iki'),
            align: 'start',
            value: 'valid_to',
            width: "7rem"
          },
        ]
      },
  
      filteredHeader() {
        return this.headers.filter((item) => {
          return !item.hide
        })
      },
  
      filterItemList() {
        return this.listData.map((item) => {
          return item
        })
      },
  
      hideFooter() {
        return this.pagination.total <= 10
      },
      canPrint() {
        return this.filterItemList.length === 0
      },
    },
    beforeDestroy() {
  
    },
    created() {
      // this.setlistParams()
    },
    methods: {
      newItem() {
        this.$router.push({
          name: 'personDocumentKindForm',
        })
      },
      getData(resetPageNr = false) {
        if (resetPageNr) {
          this.pagination.page = 1
        }
  
        this.setSortParams()
  
        const data = {
          ...this.pagination,
          search: this.searchData,
        }
  
        this.$axios
          .post(`person-document-kinds/list`, data)
          .then((res) => {
            this.listData = res.data.personDocumentKinds
            this.pagination = { ...this.pagination, ...res.data.pagination }
  
          })
          .catch((err) => {
           this.$root.$emit('DATA_ERROR', err)
          })
          .finally(() => {
            this.loading = false
            this.pageloading = false
            this.paginationloading = false
          })
      },
      updatePagination(pagination) {
        if (this.paginationloading) {
          return
        }
        this.$store.dispatch('listParams', {
            pageSize: pagination.itemsPerPage,
            page: pagination.page,
            route: this.$route.name,
        })
        this.paginationloading = true
        this.pagination.page = pagination.page
        this.pagination.pageSize = pagination.itemsPerPage
        this.pagination.sort = pagination.sortBy[0]
        this.pagination.sortDesc = pagination.sortDesc
        this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'
  
        if (!this.loading) {
          this.getData()
        }
      },
      initSearch(searchData) {
        this.searchData = searchData
        this.loading = true
        this.getData(searchData.btn)
      },
  
      editItem(item, mode) {
        this.$router.push({
          name: 'personDocumentKindForm',
          params: {
            id: item.id,
          },
        })
      },
  
      deleteItem(item) {
        this.modalDeleteItem = Object.assign({}, item)
        this.showDelete = true
      },
  
      confirmDelete(item) {
        this.loading = true
  
        this.$axios
          .delete(`person-document-kinds/${item.id}`)
          .then((res) => {
            this.$root.$emit('DATA_OK_CODE', '000111')
            this.getData()
          })
          .catch((err) => {
           this.$root.$emit('DATA_ERROR', err)
          })
          .finally(() => {
            this.loading = false
            this.showDelete = false
          })
      },
    },
  }
  </script>
  <style lang="scss" scoped>
  .potipis {
    background: #8eb693;
  
    .v-card__text {
      &.active {
        background: #2c7837;
        color: #fff;
      }
    }
  }
  .tikrina-chip {
    max-width: 110px;
  }
  </style>
  